module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Marguerite Henry\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Marguerite Henry (1902–1997) was the beloved author of such classic horse stories as "), _c('I', [_vm._v("King of the Wind")]), _vm._v(", "), _c('I', [_vm._v("Misty of Chincoteague")]), _vm._v(", and "), _c('I', [_vm._v("Stormy, Misty’s Foal")]), _vm._v(", and her work has won several Newbery Awards and Honors. ")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/M5yNuN/tc-custom/9781442488007.jpg?1730530305628",
      "alt": "This image is the cover for the book King of the Wind"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("King of the Wind\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("He was named “Sham” for the sun, this golden-red stallion born in the Sultan of Morocco’s stone stables. Upon his heel was a small white spot, the symbol of speed. But on his chest was the symbol of misfortune. Although he was swift as the desert winds, Sham’s pedigree would be scorned all his life by cruel masters and owners."), _c('br'), _c('br'), _vm._v("This is the classic story of Sham and his friend, the stable boy Agba. Their adventures take them from the sands of the Sahara to the royal courts of France, and finally to the green pastures and stately homes of England. For Sham was the renowned Godolphin Arabian, whose blood flows through the veins of almost every superior thoroughbred. Sham’s speed—like his story—has become legendary.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Aladdin\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0